import { render, staticRenderFns } from "./modifyPwd.vue?vue&type=template&id=755d20f8&scoped=true&"
import script from "./modifyPwd.vue?vue&type=script&lang=js&"
export * from "./modifyPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755d20f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('755d20f8')) {
      api.createRecord('755d20f8', component.options)
    } else {
      api.reload('755d20f8', component.options)
    }
    module.hot.accept("./modifyPwd.vue?vue&type=template&id=755d20f8&scoped=true&", function () {
      api.rerender('755d20f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/accountManager/modifyPwd.vue"
export default component.exports